

import Login from './components/Login.vue'
import taskDetail from './components/pages/taskDetail'
import callPatient from './components/pages/callPatientMain'
import completeQuestion from './components/pages/completeQuestion'

import internalQualityControl from './components/internalQualityControl/internalQualityControl'

// -- 新增需求  -- 添加 任务 列表
import TaskFilterListPage from './components/pages/TaskFilterListPage.vue'
import followupFinished from './components/pages/components/FollowupFinished.vue'

import studyPage from './components/pages/studyPage'
import waitStudy from './components/pages/waitStudyDetail'
import timeOut from './components/pages/timeOut'
import caseStudyPage from './components/pages/caseStudyPage'

// 呼叫中心工作台
import workTable from './components/pages/workTable'
import bestFollowupCase from './components/pages/bestFollowupCase.vue'
import wrongQuestionList from './components/pages/wrongQuestionList.vue'
import wrongQuestionDetail from './components/pages/wrongQuestionDetail.vue'

import testPage from './components/pages/testPage'

const routerConfig = [
  {
    path: '/workTable',
    component: workTable,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/testPage',
    component: testPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/studyPage',
    component: studyPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/caseStudyPage',
    component: caseStudyPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/bestFollowupCase',
    component: bestFollowupCase,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/completeQuestion',
    component: completeQuestion,
    meta: {
      requiresAuth: false
    }
  },{
    path: '/wrongQuestionList',
    component: wrongQuestionList,
    meta: {
      requiresAuth: false
    }
  },{
    path: '/wrongQuestionDetail',
    component: wrongQuestionDetail,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/waitStudy',
    component: waitStudy,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/taskList',
    component: TaskFilterListPage,
    meta: {
      requiresAuth: true
    }
  }, // 
  // -- 新需求 追加 任务列表页面====呼叫中心重大调整
  {
    path: '/taskDetail',
    component: taskDetail,
    meta: {
      keepAlive: false,
      requiresAuth: true
    }
  },
  {
    path: '/callPatient',
    component: callPatient,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/internalQualityControl',
    component: internalQualityControl,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/followupFinished',
    component: followupFinished,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
]
const routerConfigMenuOut = [
  // 登录
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/timeOut',
    component: timeOut,
  },
]

export default [...routerConfig, ...routerConfigMenuOut] // 导出参与多标签页处理的路由设置